const states = {
    "United States": [
        { name: "Alabama", code: "AL" },
        { name: "Alaska", code: "AK" },
        { name: "Arizona", code: "AZ" },
        { name: "Arkansas", code: "AR" },
        { name: "California", code: "CA" },
        { name: "Colorado", code: "CO" },
        { name: "Connecticut", code: "CT" },
        { name: "Delaware", code: "DE" },
        { name: "Florida", code: "FL" },
        { name: "Georgia", code: "GA" },
        { name: "Hawaii", code: "HI" },
        { name: "Idaho", code: "ID" },
        { name: "Illinois", code: "IL" },
        { name: "Indiana", code: "IN" },
        { name: "Iowa", code: "IA" },
        { name: "Kansas", code: "KS" },
        { name: "Kentucky", code: "KY" },
        { name: "Louisiana", code: "LA" },
        { name: "Maine", code: "ME" },
        { name: "Maryland", code: "MD" },
        { name: "Massachusetts", code: "MA" },
        { name: "Michigan", code: "MI" },
        { name: "Minnesota", code: "MN" },
        { name: "Mississippi", code: "MS" },
        { name: "Missouri", code: "MO" },
        { name: "Montana", code: "MT" },
        { name: "Nebraska", code: "NE" },
        { name: "Nevada", code: "NV" },
        { name: "New Hampshire", code: "NH" },
        { name: "New Jersey", code: "NJ" },
        { name: "New Mexico", code: "NM" },
        { name: "New York", code: "NY" },
        { name: "North Carolina", code: "NC" },
        { name: "North Dakota", code: "ND" },
        { name: "Ohio", code: "OH" },
        { name: "Oklahoma", code: "OK" },
        { name: "Oregon", code: "OR" },
        { name: "Pennsylvania", code: "PA" },
        { name: "Rhode Island", code: "RI" },
        { name: "South Carolina", code: "SC" },
        { name: "South Dakota", code: "SD" },
        { name: "Tennessee", code: "TN" },
        { name: "Texas", code: "TX" },
        { name: "Utah", code: "UT" },
        { name: "Vermont", code: "VT" },
        { name: "Virginia", code: "VA" },
        { name: "Washington", code: "WA" },
        { name: "West Virginia", code: "WV" },
        { name: "Wisconsin", code: "WI" },
        { name: "Wyoming", code: "WY" }
    ],
    "Canada": [
        { name: "Alberta", code: "AB" },
        { name: "British Columbia", code: "BC" },
        { name: "Manitoba", code: "MB" },
        { name: "New Brunswick", code: "NB" },
        { name: "Newfoundland and Labrador", code: "NL" },
        { name: "Nova Scotia", code: "NS" },
        { name: "Ontario", code: "ON" },
        { name: "Prince Edward Island", code: "PE" },
        { name: "Quebec", code: "QC" },
        { name: "Saskatchewan", code: "SK" }
    ]
};

const countrySelect = document.getElementById('customerCountry');
const stateDropdown = document.getElementById('stateDropdown');
const stateTextbox = document.getElementById('customerState');

function updateStateField() {
    if (countrySelect) {
        const selectedCountry = countrySelect.value;
        const stateList = states[selectedCountry];

        if (stateList) {
            // Use dropdown
            stateDropdown.innerHTML = '';
            stateList.forEach(function (state) {
                const option = document.createElement('option');
                option.value = state.code;
                option.textContent = state.name;
                stateDropdown.appendChild(option);
            });

            stateDropdown.style.display = 'block';
            stateTextbox.style.display = 'none';
            stateTextbox.value = ''; // clear textbox
        } else {
            // Use textbox
            stateDropdown.style.display = 'none';
            stateTextbox.style.display = 'block';
            stateDropdown.innerHTML = ''; // clear dropdown
        }
    }
}

// Initialize on load
document.addEventListener('DOMContentLoaded', updateStateField);

// Update on change
if (countrySelect) {
    countrySelect.addEventListener('change', updateStateField);
}

// Guest user login page on element block
if (document.querySelector('.block__main_guestlogin_wrapper')) {
    let quote_product_added_popup = localStorage.getItem("quoteProduct");

    if (quote_product_added_popup == "" || quote_product_added_popup == '[]' || quote_product_added_popup == null) {
        document.querySelector('.block__main_guestlogin_wrapper').style.display = 'none';
    } else {
        document.querySelector('.block__main_guestlogin_wrapper').style.display = 'block';
    }
}
// Guest user button click on open form
if (document.querySelector('.guestlogin-btnform')) {
    document.querySelector('.guestlogin-btnform').addEventListener("click", function (event) {
        event.preventDefault();
        let productsquoteDrawer = document.querySelector('.requestquote-drawer');
        if (productsquoteDrawer) {
            productsquoteDrawer.classList.add('quotedrawer_active');
            document.body.classList.add('body_quotedrawer_active');
            document.querySelector('.requestquote-drawer .block__main_login-form').style.display = 'none';
            document.querySelector('.requestquote-drawer .login_guest_description').style.display = 'block';
            document.getElementById('quote-guestaccount').style.display = 'block';
        } else { }
    })
}


//Guset user login submitted code
if (document.getElementById("getProductIdsButton")) {

    let isEmailValid = false;
    let customerName = document.getElementById("customerName");
    let customerEmail = document.getElementById("customerEmail");
    let customerPhone = document.getElementById("customerPhone");
    const nameError = document.getElementById('nameError');
    const emailError = document.getElementById('emailError');
    let phoneError = document.getElementById('phoneError');

    const nameRegex = /^[A-Za-z\s]+$/;
    customerName.addEventListener('input', () => {
        const namevalue = customerName.value.trim(); // Remove leading/trailing spaces for check
        const isValidPattern = nameRegex.test(namevalue);
        const hasLetter = /[A-Za-z]/.test(namevalue); // Ensure at least one letter
        const isValid = isValidPattern && hasLetter && namevalue.length > 0;
        nameError.style.display = isValid ? 'none' : 'block';
        customerName.setCustomValidity(isValid ? '' : 'Invalid name: Must contain at least one letter.');
    });

    const validateEmail = (email) => {
        var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(String(email).toLowerCase());
    }

    customerEmail.addEventListener('input', () => {
        // const isValid = customerEmail.value.checkValidity();
        // emailError.style.display = isValid ? 'none' : 'block';
        // customerEmail.setCustomValidity(isValid ? '' : 'Invalid email');
        // if (customerEmail.validity.valid) {
        //     emailError.style.display = "none";
        //     customerEmail.setCustomValidity(""); // Clear custom error
        // } else {
        //     emailError.style.display = "block";
        //     customerEmail.setCustomValidity("Invalid email");
        // }
        if (validateEmail(customerEmail.value)) {
            emailError.style.display = "none";
            isEmailValid = true;
            console.log("isEmailValid", isEmailValid);
        } else {
            emailError.style.display = "block";
            isEmailValid = false;
        }
    });

    customerPhone.addEventListener('input', () => {
        const value = customerPhone.value.trim();

        if (value === '') {
            phoneError.style.display = 'none';
            customerPhone.setCustomValidity('');
            return;
        }

        const phoneRegex = /^[0-9+\-\(\)\s]{7,20}$/;
        const isValid = phoneRegex.test(value);

        phoneError.style.display = isValid ? 'none' : 'block';
        customerPhone.setCustomValidity(isValid ? '' : 'Invalid phone number');
    });

    const submitBtn = document.querySelector('#getProductIdsButton');
    const loader = document.getElementById('quoteLoader');
    let isSubmitting = false;

    submitBtn.addEventListener('click', (event) => {
        // Prevent double submission
        if (isSubmitting) {
            event.preventDefault();
            return;
        }

        const guestForm = document.querySelector('#quote-guestaccount form');
        const honeypot = guestForm.querySelector('input[name="hp_email"]');
        
        // Honeypot check
        if (honeypot && honeypot.value.trim() !== '') {
            event.preventDefault();
            console.log("Bot detected via honeypot, submission blocked.");
            alert("Spam detected! Please try again.");
            return false;
        }

        // Get form values
        let customerNamevalue = document.getElementById("customerName").value;
        let customerEmailvalue = document.getElementById("customerEmail").value;
        let customerPhonevalue = document.getElementById("customerPhone").value;
        let customerCountry = document.getElementById("customerCountry").value;
        let tags = document.getElementById("tags").value;
        let salesperson = document.getElementById("salesperson").value;
        let stateDropdown = document.getElementById("stateDropdown");
        let stateTextbox = document.getElementById("customerState");
        let state;
        
        if (customerCountry == 'United States' || customerCountry == 'Canada') {
            state = stateDropdown.value;
        } else {
            state = stateTextbox.value;
        }

        // Basic validation
        if (customerNamevalue === '' || customerEmailvalue === '') {
            return;
        }
        
        event.preventDefault();

        // Name validation
        const namevalue = customerName.value.trim();
        const isValidPattern = nameRegex.test(namevalue);
        const hasLetter = /[A-Za-z]/.test(namevalue);
        const isNameValid = isValidPattern && hasLetter && namevalue.length > 0;

        if (!isNameValid) {
            nameError.style.display = 'block';
            customerName.setCustomValidity('Invalid name');
            if (customerName) {
                customerName.scrollIntoView({ behavior: 'smooth' });
            }
            return;
        } else {
            nameError.style.display = 'none';
            customerName.setCustomValidity('');
        }

        // Email validation
        if (!isEmailValid) {
            emailError.style.display = 'block';
            customerEmail.setCustomValidity('Invalid email');
            if (customerEmail) {
                customerEmail.reportValidity();
                customerEmail.scrollIntoView({ behavior: 'smooth' });
            }
            return;
        } else {
            emailError.style.display = 'none';
            customerEmail.setCustomValidity('');
        }

        // If we get here, validation passed - NOW disable the button
        isSubmitting = true;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
         loader.classList.add('active'); // Show loader

        // Collect products
        let products = [];
        let guest_stockqty = [];
        document.querySelectorAll('.quotepopup-product-item').forEach(item => {
            let variantId = item.querySelector('.itemvariantid')?.value || "";
            let quantity = item.querySelector('.itemqty')?.value || "";
            let price = item.querySelector('.itemprice')?.value || "";
            let stockcurrent_qty = '';
            if (item.querySelector('.itemqty')) {
                stockcurrent_qty = item.querySelector('.itemqty').getAttribute('data-currentqty');
            }
            if (variantId !== '') {
                products.push({
                    variantId: variantId,
                    quantity: quantity,
                    price: price
                });

                if (stockcurrent_qty == 0) {
                    guest_stockqty.push(variantId);
                }
            }
        });

        async function sendBackInStockRequest(variantId) {
            const guest_payload1 = {
                "data": {
                    "type": "back-in-stock-subscription",
                    "attributes": {
                        "profile": {
                            "data": {
                                "type": "profile",
                                "attributes": {
                                    "email": `${customerEmailvalue}`,
                                }
                            }
                        },
                        "channels": ["EMAIL"],
                    },
                    "relationships": {
                        "variant": {
                            "data": {
                                "type": "catalog-variant",
                                "id": `$shopify:::$default:::${variantId}`
                            }
                        }
                    }
                }
            };
            const guest_requestOptions = {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "revision": "2024-06-15"
                },
                body: JSON.stringify(guest_payload1),
            };

            try {
                const result = await fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=REu3pC", guest_requestOptions);
                const contentType = result.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                    const response = await result.json();
                    console.log("Success:", response);
                } else {
                    console.log("Success with no content (204 or empty body)");
                }
            } catch (error) {
                console.log("Error:", error);
            }
        }

        async function processAllVariantsSequentially(variants) {
            for (const variantId of variants) {
                await sendBackInStockRequest(variantId);
            }
        }

        const requestId = crypto.randomUUID();
        const dataToSend = {
            requestId: requestId,
            customerName: customerNamevalue,
            customerEmail: customerEmailvalue,
            customerPhone: customerPhonevalue,
            customerCountry: customerCountry,
            tags: tags,
            salesperson: salesperson,
            products: products,
            state: state
        };

        $.ajax({
            type: 'POST',
            url: 'https://app.valuetronics.com/requestquotewithoutloginphone.php',
            data: JSON.stringify(dataToSend),
            dataType: 'json',
            success: function (response) {
                console.log("Success:", response.message);
                 // ✅ Hide loader on error
                loader.classList.remove('active');
                if (response.message == "Draft order Created successfully.") {
                    $('.requestquote-customerform-wrapper').hide();
                    $('.thankyou-section .quote-error-icon').hide();
                    $('.thankyou-section .quote-success-icon').show();
                    $('.thankyou-section').addClass('show-thankyou-block');
                    $('.quotepopup-section').css('display', 'none').addClass('empty-quotesection');
                    $('#quoteproduct-listform').addClass('quote-products-hide').css('display', 'none');
                    $('.quotedrawer-product-mainheading').css('display', 'none');
                    $('.quotedrawer-product-submittedcontent').addClass('quote-submit-active').css('display', 'block');
                    localStorage.removeItem("quoteProduct");
                    
                    // Run only if stockqty has values
                    if (guest_stockqty.length > 0) {
                        processAllVariantsSequentially(guest_stockqty);
                    }
                } else {
                    $('.requestquote-customerform-wrapper').hide();
                    $('.thankyou-section .quote-success-icon').hide();
                    $('.thankyou-section .quote-error-icon').show();
                    $('.thankyou-section').addClass('show-thankyou-block');
                    $('.thankyou-section h3').text(response.message);
                    $('.thankyou-section .thankyou-submsg-txt').empty();
                    
                    // Re-enable button on error response
                    isSubmitting = false;
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Submit';
                }
            },
            error: function (error) {
                 // ✅ Hide loader on error
                 loader.classList.remove('active');
                isSubmitting = false;
                submitBtn.disabled = false;
                submitBtn.textContent = 'Submit';
                console.error("Error:", error);
                alert('An error occurred. Please try again.');
            }
        });

        console.log("Submitted Data:", dataToSend);
        return false;
    });
}